// Library methods
import { useTranslation } from "react-i18next";

// MUI Components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Components
import { DiagonalArrowsIcon } from "../../../assets/icons";

// Styles
import { CustomIconButtonDark } from "../../../styles/muiStylesHelper";

const DevicesListHeader = ({
  isActive,
  setIsActive,
  setExpandDevicesModal,
  containerProps,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      gap="16px"
      {...containerProps}
    >
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" alignItems="center" gap="16px">
          <Typography fontSize={{ xs: "16px", md: "20px" }} fontWeight="bold">
            {t("devices_title")}
          </Typography>
          <Typography
            sx={{
              fontWeight: isActive === "all" ? 600 : 400,
              borderBottom: isActive === "all" ? "1px solid #000" : "none",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={() => setIsActive("all")}
          >
            {t("word_all")}
          </Typography>
          <Typography
            component="div"
            variant="p"
            sx={{
              fontWeight: isActive === "unlinked" ? 600 : 400,
              borderBottom: isActive === "unlinked" ? "1px solid #000" : "none",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={() => setIsActive("unlinked")}
          >
            {t("word_unlinked")}
          </Typography>
          <Typography
            component="div"
            variant="p"
            sx={{
              fontWeight: isActive === "linked" ? 600 : 400,
              borderBottom: isActive === "linked" ? "1px solid #000" : "none",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={() => setIsActive("linked")}
          >
            {t("word_linked")}
          </Typography>
        </Box>
        {setExpandDevicesModal && (
          <Tooltip title={t("view_all_devices")}>
            <IconButton
              aria-label="expand-devices"
              size="medium"
              sx={CustomIconButtonDark}
              onClick={setExpandDevicesModal}
            >
              <DiagonalArrowsIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default DevicesListHeader;
